// extracted by mini-css-extract-plugin
module.exports = {"element":"a10a3f92e9--element--hhgQA"};